'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { Job } from '@/interfaces/workable';
import DefaultVariant from './variants/Default';
import WithHeaderLightCards from './variants/WithHeaderLightCards';

/**
 * Props for `JobPostCardGrid`. Jobs are fetched server-side in `server.tsx`
 * and passed in; each variant falls back to a client fetch (via
 * `useWorkableJobs`) when this array is empty.
 */
export type JobPostCardGridProps =
  SliceComponentProps<Content.CardGridSlice> & {
    jobs?: Job[];
  };

const JobPostCardGrid: FC<JobPostCardGridProps> = ({ slice, jobs = [] }) => {
  if (slice.variation === 'default') {
    return <DefaultVariant slice={slice} initialJobs={jobs} />;
  }

  if (slice.variation === 'withHeaderLightCards') {
    return <WithHeaderLightCards slice={slice} initialJobs={jobs} />;
  }

  return null;
};

export default JobPostCardGrid;
